<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="text-right">
                                    <button type="submit" v-b-modal.modal-Bonus class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Bonus</button>
                                </div>
                                <div class="row mb-4">
                                    <div class="table-search col-md-3">
                                        <label>Start Date</label>
                                        <datetime @input="getBonus()" zone='local' v-model="sorting.start_date" value-zone='local' type="date" input-class="form-control"></datetime>
                                    </div>
                                    <div class="table-search col-md-3">
                                        <label>End Date</label>
                                        <datetime @input="getBonus()" zone='local' v-model="sorting.end_date" value-zone='local' type="date" input-class="form-control"></datetime>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Agent Name</label>
                                        <v-select :clearable="true" @input="getBonus()" label="name" :reduce="user_agent => user_agent.id" v-model="sorting.agent_id" :options="user_agent">
                                            <template v-slot:option="option">
                                                {{ option.name }} - {{option.email}}
                                            </template>
                                            <template #selected-option="option">
                                                {{ option.name }} - {{option.email}}
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-md-3">
                                        <label>Tier Agent</label>
                                        <select class="form-control" @change="getBonus()" v-model="sorting.tier">
                                            <option value="" selected></option>
                                            <option value="BRONZE">BRONZE</option>
                                            <option value="SILVER">SILVER</option>
                                            <option value="GOLD">GOLD</option>
                                            <option value="DIAMOND">DIAMOND</option>
                                        </select>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                                        <label class="custom-control-label" for="all_id"></label>
                                                    </div>
                                                </th>
                                                <th>Agent</th>
                                                <th>Tier</th>
                                                <th>Event Conditions</th>
                                                <th>Bonus</th>
                                                <th>Claim Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="data in bonus.data" :key="data.id">
                                                <td width="100px" v-on:click.stop=""> 
                                                    <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                                        <input type="checkbox" class="custom-control-input" v-model="del_bonus" :value="data.id" :id="data.id">
                                                        <label class="custom-control-label" :for="data.id"></label>
                                                    </div>
                                                </td>
                                                <td>{{data.agent.name}}</td>
                                                <td>{{data.bonus.tier}}</td>
                                                <td>Min. {{data.bonus.slot}} events to claim</td>
                                                <td>{{data.bonus.bonus | formatRupiah}}</td>
                                                <td>{{data.claim_date | formatDate}}</td>
                                            </tr>
                                        
                                        </tbody>
                                        
                                    </table>
                                    <p v-if="bonus.total === 0" class="text-center no-data">Bonus data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="bonus"
                                                :sorting="sorting"
                                                @paginate="getBonus()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Bonus Data Still Empty</h2>
                                    <p>On this page you can create bonus</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Bonus class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Bonus</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-action" v-if="del_bonus.length !== 0">
                <div class="card-body">
                    <div class="float-left text-white mt-1">
                        <span v-on:click.prevent="del_bonus = []" class="times"><i class="uil uil-times"></i></span>
                        <span><span class="badge">{{del_bonus.length}}</span> bonus selected</span>
                    </div>
                    <div class="float-right">
                        <div v-on:click.prevent="alertDeleteBonus()" class="btn btn-danger">
                            <i class="uil uil-times"></i> Delete
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <modal-form :del_bonus="del_bonus" @getBonus="_getBonus(),del_bonus = []"></modal-form>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import ModalForm from '../bonus/ModalForm.vue'
    import moment from 'moment'
    import vSelect from 'vue-select'
    import { Datetime } from 'vue-datetime';

    export default {
        name: "Bonus",
        components: {
            VuePagination,
            ModalForm,
            vSelect,
            Datetime
        },
        data(){
            return {
                del_bonus:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this.getUserAgent()
            this._getBonus()
        },
        filters:{
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY')
            },
            formatRupiah:function(val){
                if(val){
                    let value = (parseInt(val)/1).toFixed(0).replace('.', ',')
                    return "Rp " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }else{
                    return '-'
                }
            }
        },
        computed:{
            ...mapState('BonusControl', {
                bonus: state => state.bonus,
                user_agent: state => state.user_agent,
                sorting: state => state.sorting
            }),
            selectAll: {
                get: function () {
                    return this.bonus.data ? this.del_bonus.length == this.bonus.data.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.bonus.data.forEach(function (bonus) {
                            if(bonus.id !== 1){
                                selected.push(bonus.id);
                            }
                        });
                    }
                    this.del_bonus = selected;
                }
            }
        },
        methods: {
            ...mapActions('BonusControl', ['getBonus','deleteBonus','getUserAgent']),
            ...mapMutations('BonusControl', ['CLEAR_BONUS','ASSIGN_FORM']),
            
            _getBonus:function(){
                this.getBonus().then(() => {
                    if(this.bonus.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            editBonus:function(data){
                this.ASSIGN_FORM(data)
                this.$bvModal.show('modal-Bonus')
            },
            alertDeleteBonus:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this bonus data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteBonus(this.del_bonus).then(
                            this.$toast.success('Successfully Deleting Agent Bonus'),
                            this.del_bonus = []
                        )
                    }
                })
            },
        },
        destroyed(){
            this.CLEAR_BONUS()
        }
    };

</script>

<style scoped>
    .search-f >>> input{
        border-radius: 5px !important;
    }
    .search-f >>> .search-group-btn{
        display: none !important;
    }
</style>